<ngb-alert class="mb-0" [type]="type" [dismissible]="false">
  <div *ngIf="text"><i [class]="icon"></i> {{ text }}</div>
  <div [innerHTML]="html" *ngIf="html"></div>
</ngb-alert>
